export class ArcBuilderRow {
  public SelectedFieldType: number;
  public SelectedFieldId: number;
  public IsDefault: boolean;
  public RangeStart: number;
  public RangeEnd: number;
  public Multiplier: number;
  public MultiplierPrice: number;
  public BasePrice: number;

  constructor() {
    this.SelectedFieldType = 0;
    this.SelectedFieldId = 0;
    this.IsDefault = false;
    this.RangeStart = 0;
    this.RangeEnd = 0;
    this.Multiplier = 0;
    this.MultiplierPrice = 0;
    this.BasePrice = 0;
  }
}
